module.exports = __webpack_public_path__ + "img/forward-fill.185ee868.svg";